import { useMemo } from 'react';

import { useCacheQuery } from '../../../hooks/use-cache-query';
import { GetLastMindMessageDocument } from '../../types/api/graphql';

export function useLastMindMessage(conversationId: string | null | undefined) {
  const { data: lastMindMessageData, loading: lastMindMessageDataLoading } =
    useCacheQuery(GetLastMindMessageDocument, {
      variables: {
        conversationId: conversationId ?? '',
      },
    });

  const data = useMemo(
    () => lastMindMessageData?.lastMindMessage?.mindData ?? null,
    [lastMindMessageData]
  );

  return {
    data,
    loading: lastMindMessageDataLoading,
  };
}
